import * as React from 'react';

function SvgRightArrow(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 21" {...props}>
    <path
      fill="#fff"
      d="M13.635 11.251a.954.954 0 0 0 0-1.501l-.897-.722-.09-.077-1.79-1.437L1.816.25C.766-.549-.575.73.263 1.731l7.758 8.771-7.758 8.772c-.34.383-.35.956 0 1.353a1.14 1.14 0 0 0 1.553.126l10.832-8.7q.042-.034.084-.072z"
    />
  </svg>)
}
export default SvgRightArrow;
